import React, { useState, useEffect, useRef } from "react";
import "../styles/Hero.css";

import img1 from "../Assets/Images/afvs1.jpg";
// import img2 from "../Assets/Images/afvs.jpg";
// import img3 from "../Assets/Images/afvs2.jpg";

const slides = [
  { img: img1 },
  // { img: img2 },
  // { img: img3 },
];

function Hero() {
  const [current, setCurrent] = useState(0);
  const slidesLength = useRef(slides.length);

  useEffect(() => {
    if (slidesLength.current <= 1) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slidesLength.current);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-section">
      <div className="slider-wrapper">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === current ? "active" : ""}`}
          >
            <img src={slide.img} alt={`Slide ${index}`} className="hero-image" />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Hero;
